import { IconX } from "../../../STATIC";

class FilterizoIconX {

  /**
   * 
   * @param {import("./__typedef").filterformat} format 
   * @param {*} size 
   * @param {*} color 
   * @returns 
   */
  static Get(format, size, color){
    switch(format){
      case "date": return IconX.Get("awesome", "calendar", size, color);
      case "email": return IconX.Get("entypo", "email", size, color);
      case "id": return IconX.Get("muicom", "identifier", size, color);
      case "lang": return IconX.Get("ionic", "language", size, color);
      case "multi-select": return IconX.Get("feather", "list", size, color);
      case "number": return IconX.Get("oct", "number", size, color);
      case "phone": return IconX.Get("entypo", "phone", size, color);
      case "select": return IconX.Get("ant", "playcircleo", size, color);
      default: case "text": return IconX.Get("ionic", "text", size, color);
      case "time": return IconX.Get("muicom", "clock-time-nine-outline", size, color);
      case "url": return IconX.Get("ant", "link", size, color);
      case "user": return IconX.Get("awesome", "user-circle-o", size, color);
    }
  }

}

export default FilterizoIconX;